import { FileUploaderStatus } from './file-uploader-status.enum';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { Id } from '@ideom/http';

export interface FileUploaderFile {
  file: File;
  status: FileUploaderStatus;
  subscription?: Subscription;
  chunks?: FileUploaderFileChunk[];
  fileId?: string;
  fileIdSubject?: ReplaySubject<Id>;
  progress?: FileUploaderFileProgress;
  errors?: string[];
  fileSizeMb?: number;
}

export class FileUploaderFileProgress {
  chunksTotal: number;
  chunksCompleted: number;
  chunksProcessing: number;
  percentageCompleted: number;
  percentageProcessing: number;
}

export interface FileUploaderFileChunk {
  offset: number;
  count: number;
  data: Blob;
  status: FileUploaderStatus;
  observable?: Observable<Id>;
}
